module.exports = __webpack_public_path__ + "static/media/logo-bankapi-3x.53706509.png";